/* istanbul ignore next */
if (window.appConfig.PUBLIC_PATH) {
  // Dynamically set the public path for Webpack assets, This will be added by the server based on the request
  __webpack_public_path__ = window.appConfig.PUBLIC_PATH;
}
export {};
